import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useApp from '@/pages/App.context';
import useReview from '@/pages/ReviewLayout.context';
import Button from '@/components/Button';
import styles from './Approved.module.scss';

const Approved = () => {
  const { i18n, t } = useTranslation(['review']);
  const { reviewerStatusId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { setAppTitle } = useApp();
  const { review } = useReview();
  const lang = i18n.language ?? 'en';

  useEffect(() => {
    setAppTitle(t('review:approved.title'));
  }, [setAppTitle, t]);

  if (!review || location.state?.reviewerStatusId !== reviewerStatusId) {
    void navigate(
      `https://www.swipesign.io/${lang !== 'en' ? `${lang}/` : ''}`,
      {
        replace: true,
      }
    );
  }

  return (
    <div className={styles.pane}>
      <h1 className={styles.h1}>{t('review:approved.headline')}</h1>
      <div
        className={styles.content}
        dangerouslySetInnerHTML={{
          __html: t('review:approved.desc').replaceAll('\n', '<br>'),
        }}
      />
      <div className={styles.buttons}>
        <Button
          as="link"
          variant="primary"
          to={`https://www.swipesign.io/${lang !== 'en' ? `${lang}/` : ''}`}
        >
          {t('review:approved.cta')}
        </Button>
      </div>
    </div>
  );
};

export default Approved;
